import { RECORD_ID_RE } from '../../api/_lib/record-id.js';
import { MAX_MAIL_BIJLAGEN_BYTES } from './factuurconcept.js';

/** Portable server evidence. No model-provided bytes, links or filenames. */
export interface OfferteDocument {
  versie: 1;
  leadId: string;
  referentie: string;
  ontvanger: string;
  bronHash: string;
  pdfHash: string;
  bestandsnaam: string;
  mimeType: 'application/pdf';
  grootte: number;
}
export function leesOfferteDocumenten(raw: unknown): OfferteDocument[] | null {
  if (!Array.isArray(raw) || !raw.length || raw.length > 10) return null;
  const ids = new Set<string>(), uit: OfferteDocument[] = [];
  for (const r of raw) {
    if (!r || r.versie !== 1 || typeof r.leadId !== 'string' || !RECORD_ID_RE.test(r.leadId)
      || typeof r.referentie !== 'string' || !/^L-\d{1,10}$/.test(r.referentie)
      || typeof r.ontvanger !== 'string' || !/^[^\s<>@,;]+@[^\s<>@,;]+\.[a-z]{2,}$/i.test(r.ontvanger)
      || typeof r.bronHash !== 'string' || !/^[a-f0-9]{64}$/.test(r.bronHash)
      || typeof r.pdfHash !== 'string' || !/^[a-f0-9]{64}$/.test(r.pdfHash)
      || r.mimeType !== 'application/pdf' || r.bestandsnaam !== `offerte-${r.referentie}.pdf`
      || !Number.isSafeInteger(r.grootte) || r.grootte <= 0 || r.grootte > MAX_MAIL_BIJLAGEN_BYTES || ids.has(r.leadId)) return null;
    ids.add(r.leadId);
    uit.push({ versie:1,leadId:r.leadId,referentie:r.referentie,ontvanger:r.ontvanger,bronHash:r.bronHash,
      pdfHash:r.pdfHash,bestandsnaam:r.bestandsnaam,mimeType:r.mimeType,grootte:r.grootte });
  }
  return uit.reduce((n,d)=>n+d.grootte,0) > MAX_MAIL_BIJLAGEN_BYTES ? null : uit;
}
export const offerteDocumentSleutel = (d: OfferteDocument) => `${d.leadId}:${d.bronHash}:${d.pdfHash}`;
export function offertesUitActies(raw: unknown): OfferteDocument[] {
  if (!Array.isArray(raw)) return [];
  const uit = new Map<string,OfferteDocument>();
  for (const a of raw) {
    if (a?.verb !== 'bereid_offerteconcept' || a.uitkomst?.besluit !== 'akkoord' || a.uitkomst.ok !== true) continue;
    const docs = leesOfferteDocumenten(a.uitkomst.offerteDocumenten);
    if (!docs) throw new Error('Het offertebewijs is onvolledig. Bereid de offerte opnieuw voor.');
    for (const d of docs) {
      const oud = uit.get(d.leadId);
      if (oud && offerteDocumentSleutel(oud) !== offerteDocumentSleutel(d)) throw new Error('Twee versies van dezelfde offerte geselecteerd. Controleer het concept.');
      uit.set(d.leadId,d);
    }
  }
  const docs = [...uit.values()];
  if (docs.length && !leesOfferteDocumenten(docs)) throw new Error('De offertes overschrijden de bijlagenlimiet.');
  return docs;
}
